import { createSlice } from '@reduxjs/toolkit';
import OrderIlacSecilenler from 'src/models/Order/Ilac/OrderIlacSecilenler';
import VwHbsOrderIlacDTO from 'src/models/Order/VwHbsOrderIlacDTO';
import MapReducerPayloads from 'src/models/store/MapReducerPayloads';
import { VwStokaraRequest } from 'src/services/StokEczane/StokDurumApi';

export interface IOrderState {
  tabState: number;
  baseGrupAddDialogIsOpen: boolean;
  baseGrupSelectedIndex: number;
  baseGrupSelectedGrupId: number;
  ilacEkleDialogIsOpen: boolean;
  orderDepoDurumFilter: VwStokaraRequest;
  orderIlacSecilenRow: OrderIlacSecilenler[];
  isAddIlacsToGroup: boolean;
  muadilBarkodNo: number;
  muadilDialog: boolean;
  rowmodelGrupList: Array<any>
  rowmodelDisteminList: Array<any>
  editedvalues: Array<VwHbsOrderIlacDTO>
}
const OrderIlacSlice = createSlice<
  IOrderState,
  MapReducerPayloads<
    IOrderState,
    {
      setState: IOrderState;
      setTabState: number;
      setBaseGrupAddDialogIsOpen: boolean;
      setBaseGrupSelectedIndex: number;
      setBaseGrupSelectedGrupId: number;
      setIlacEkleDialogIsOpen: boolean;
      setOrderDepoDurumFilter: VwStokaraRequest;
      setOrderIlacSecilenRow: OrderIlacSecilenler[];
      setIsAddIlacsToGroup: boolean;
      setMuadilBarkodNo: number;
      setMuadilDialog: boolean;
      setRowmodelGrupList: Array<any>
      setRowmodelDisteminList: Array<any>
      setEditedvalues: Array<VwHbsOrderIlacDTO>

    }
  >
>({
  name: 'orderIlac',
  initialState: {
    tabState: 1,
    baseGrupAddDialogIsOpen: false,
    baseGrupSelectedIndex: 0,
    baseGrupSelectedGrupId: null,
    ilacEkleDialogIsOpen: false,
    orderDepoDurumFilter: new VwStokaraRequest(),
    orderIlacSecilenRow: new Array<OrderIlacSecilenler>(),
    isAddIlacsToGroup: false,
    muadilBarkodNo: 0,
    muadilDialog: false,
    rowmodelGrupList: [],
    rowmodelDisteminList: [],
    editedvalues: [],
  },
  reducers: {
    setState: (state, action) => action.payload,
    setTabState: (state, action) => {
      state.tabState = action.payload;
    },
    setBaseGrupAddDialogIsOpen: (state, action) => {
      state.baseGrupAddDialogIsOpen = action.payload;
    },
    setBaseGrupSelectedIndex: (state, action) => {
      state.baseGrupSelectedIndex = action.payload;
    },
    setBaseGrupSelectedGrupId: (state, action) => {
      state.baseGrupSelectedGrupId = action.payload;
    },
    setIlacEkleDialogIsOpen: (state, action) => {
      state.ilacEkleDialogIsOpen = action.payload;
    },
    setOrderDepoDurumFilter: (state, action) => {
      state.orderDepoDurumFilter = action.payload;
    },
    setOrderIlacSecilenRow: (state, action) => {
      state.orderIlacSecilenRow = action.payload;
    },
    setIsAddIlacsToGroup: (state, action) => {
      state.isAddIlacsToGroup = action.payload;
    },
    setMuadilBarkodNo: (state, action) => {
      state.muadilBarkodNo = action.payload;
    },
    setMuadilDialog: (state, action) => {
      state.muadilDialog = action.payload;
    },
    setRowmodelGrupList: (state, action) => {
      state.rowmodelGrupList = action.payload;
    },
    setRowmodelDisteminList: (state, action) => {
      state.rowmodelDisteminList = action.payload;
    },
    setEditedvalues: (state, action) => {
      state.editedvalues = action.payload;
    },
  }
});
export default OrderIlacSlice;
